import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/research-center/_research-center/$researchCenterId/_layout/lab/_layout/')({
  beforeLoad: ({ preload, params }) => {
    if (!preload) {
      throw redirect({
        to: '/research-center/$researchCenterId',
        replace: true,
        params,
      });
    }
  },
});
